import './instalaciones.css';

// 🔥 IMPORTAR IMÁGENES
import inst1 from '../assets/images/Instalaciones.png';

const images = [
  inst1
];

function Instalaciones() {
  return (
    <section className="instalaciones">

      <div className="instalaciones-wrapper">

                {/* 🔥 TEXTO IZQUIERDA */}
                <div className="instalaciones-text">
                <h2>
                    Nuestras <br /> Instalaciones
                </h2>
            </div>

            {/* 🔥 IMÁGENES DERECHA */}
            <div className="instalaciones-images">
                {images.map((img, i) => (
                    <img key={i} src={img} alt="instalacion" className={`img-${i}`} />
                ))}
            </div>
      </div>

    </section>
  );
}

export default Instalaciones;